import './index.css'

import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useThemeJson } from '../../../data/tenantfiles'
import { useAllTenantFiles, useFile } from '../../../data/tenantfiles/hooks'
import { ThemeContext } from '../../context/ThemeContextProvider'
import SignInSignOutButton from './SignInSignOutButton'

export default function Header(): React.ReactElement {
  const { t } = useTranslation()

  const { data: filelist } = useAllTenantFiles()

  const { data: themeJson } = useThemeJson('cockpit/branding/theme.json')
  const { error } = useFile(themeJson?.logo?.path as string)

  const { imageBase64 } = useContext(ThemeContext)

  return (
    <header className="flex justify-content-between align-items-center">
      <img
        src={
          themeJson?.logo?.isEnabled &&
          !error &&
          filelist?.some(e => e.uri.includes(themeJson.logo?.path as string))
            ? imageBase64
            : '/customization/default/logo.svg'
        }
        alt="Logo"
        className="logo"
      />
      <div className="hidden sm:block">
        <span className="font-bold">
          {themeJson?.title?.isEnabled ? themeJson?.title.value : t('common.app.title')}
        </span>
      </div>
      <div>
        <SignInSignOutButton />
      </div>
    </header>
  )
}
